import { useDashboardFiltersStore } from "./useDashboardFiltersStore";
import { useProjectFiltersStore } from "./useProjectFiltersStore";
import { useInvestorInvestmentFiltersStore } from "./useInvestorInvestmentFiltersStore";
import { useInvestorDocumentFiltersStore } from "./useInvestorDocumentFiltersStore";
import { useHubProfileStore } from "./useHubProfileStore";

/**
 * Resets org-scoped filter and view stores during organization switching.
 *
 * Excluded by design:
 * - Main listings (investments, investors, beneficiaries, contracts) keep their
 *   filters + pagination in the URL, not Zustand — the org switch hook drops the
 *   query string instead (useSwitchOrganization.onSuccess).
 * - useNotificationFiltersStore — notifications endpoint scopes by user_id, not org
 * - useInvestmentViewModeStore — kanban/table/list is a UI preference, not data
 *
 * When adding or removing an org-scoped filter store, update this function.
 */
export const resetAllFilterStores = () => {
  useDashboardFiltersStore.getState().reset();
  useProjectFiltersStore.getState().reset();
  useInvestorInvestmentFiltersStore.getState().reset();
  useInvestorDocumentFiltersStore.getState().reset();
  useHubProfileStore.getState().reset();
};
